
export enum PoolNodeStatus {
    UNINITIALIZED ='Uninitialized',
	ERROR = 'Error',
	READY = 'Ready',
	WARNING ='Warning',
	PROVISIONING = 'Provisioning',
	TOKEN_EXPIRED= 'TokenExpired',
	TOKEN_WILL_EXPIRE= 'TokenWilExpire',
	TOKEN_UNASSIGNED= 'TokenUnassigned'

}
